import { Order  } from "../../classes";

const OrderModule = {
  namespaced: true,
  state: {
  },
  actions: {
    getOrder: async ({ commit }, payload) => {
      try {
        const data = await Order.getOrder(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getOrderByMeter: async ({ commit }, payload) => {
      try {
        const data = await Order.getOrderByMeter(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getOrderBetweenDateByMeter: async ({ commit }, payload) => {
      try {
        const data = await Order.getOrderBetweenDateByMeter(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getLastOrderByMeter: async ({ commit }, payload) => {
      try {
        const data = await Order.getLastOrderByMeter(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getLastOrderByContract: async ({ commit }, payload) => {
      try {
        const data = await Order.getLastOrderByContract(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    createOrder: async ({ commit }, payload) => {
      try {
        const data = await Order.createOrder(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    cancelOrderInvoicePayment: async ({ commit }, payload) => {
      try {
        const data = await Order.cancelOrderInvoicePayment(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    sendOrder: async ({ commit }, payload) => {
      try {
        const data = await Order.sendOrder(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getOrderUnPaidCoutByMeter: async ({ commit }, payload) => {
      try {
        const data = await Order.getOrderUnPaidCoutByMeter(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {

  },
  mutations: {

  }
};
export default OrderModule;
